import { render } from "./progressbar.vue?vue&type=template&id=3073c23e"
import script from "./progressbar.vue?vue&type=script&lang=js"
export * from "./progressbar.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__